import Vue from 'vue'
import axios from 'axios'
import rwConfig from './rwConfig.js'
import router from '@/router'

import { Message } from 'element-ui';
// import { Notify, Toast } from 'vant'

//由于是外部引入的js，如果在此文件里要跳转，需要实例化vue并传入路由
var vueObj = new Vue({ router });

// var apiURL = rwConfig.ApiUrl;
var apiPostDomain = (document.domain).substring(((document.domain).indexOf('.')) + 1, (document.domain).length);
var postHeader = 'https';
// if (apiPostDomain == 'sell.51zsxn.com') {
//   postHeader = 'https';
// }
// var apiURL = postHeader + '://api.' + apiPostDomain;

// var apiURL = postHeader + '://vapi.nfncb.richwisd.net'
var apiURL = postHeader + '://visual.bjseed.com.cn/visual/api/index.php/' //农村报
// var apiURL = postHeader + '://vapi.con.jnu-mris.cn/visual/api/index.php' //会议

var PRIVATE_KEY = rwConfig.PrivateKey;
var ClientDefaultLang = rwConfig.ClientDefaultLang;
var wwwURL = rwConfig.WwwUrl;
// var DoMain=rwConfig.DoMain;
var DoMain = (document.domain).substring(((document.domain).indexOf('.')) + 1, (document.domain).length);
var RootDirName = rwConfig.RootDirName;
var ClientTime = (new Date()).getTime();

var Crypto = require('@/assets/js/cryptojs/cryptojs.js').Crypto;

var postApi = axios;

export default class rwJS {

  //加密，与rwFramework对应加解密
  rwEncode(data) {
    data = JSON.stringify(data);

    var mode = new Crypto.mode.ECB(Crypto.pad.pkcs7);

    var key = Crypto.charenc.UTF8.stringToBytes(PRIVATE_KEY);
    var Info = Crypto.DES.encrypt(data, key, { mode: mode });

    return Info;
  }
  //解密，与rwFramework对应加解密
  rwDecode(data) {
    var mode = new Crypto.mode.ECB(Crypto.pad.pkcs7);
    var key = Crypto.charenc.UTF8.stringToBytes(PRIVATE_KEY);
    var Info = Crypto.DES.decrypt(data, key, { mode: mode });
    //分类数据19个数字js精度丢失操作
    // var taskId = Info.match(/[0-9]{19}/g)
    // var x = Info.replace(taskId, `"${taskId}"`)
    Info = JSON.parse(Info);
    return Info;
  }

  //简单封装axios
  rwRequest(obj) {
    var thisJS = this;
    //加载状态
    // if(thisJS.isMobile()){
    //   Toast.loading({
    //     duration:0,
    //     forbidClick: true,
    //   });
    // }
    //判断是否为上传文件，如果是则不加密并且obj.data为form对象，需要把ClientTime、rwCookieID和CliengLang加上
    if (obj.config && obj.config.headers && obj.config.headers['content-type'] == 'multipart/form-data') {
      obj.data.append('ClientTime', ClientTime);
      obj.data.append('rwCookieID', thisJS.getLocalSave('rwCookieID'));
      obj.data.append('CliengLang', thisJS.getClientLang());
    } else {
      //数据中加入必要参数
      obj.data['ClientTime'] = ClientTime;
      obj.data['rwCookieID'] = thisJS.getLocalSave('rwCookieID');
      obj.data['CliengLang'] = thisJS.getClientLang();
      obj.data['IsMobile'] = thisJS.isMobile();
      obj.data = thisJS.rwEncode(obj.data);
    }
    return new Promise(function (resolve, reject) {
      postApi.post(apiURL + obj.url, obj.data, obj.config ? obj.config : {}).then(res => {
        // Toast.clear();
        if (res.status != 200) {
          // if(thisJS.isMobile()){

          //   Notify({ 
          //     type: 'danger', 
          //     message: '网络异常：'+res.statusText,
          //     duration:3000,
          //   });
          // }else{
          Message.error('网络异常：' + res.statusText);
          // }
          return;
        }
        var data = {};
        //判断是否为下载文件，如果是则不解密，否则解密
        if (obj.config || (obj.config && obj.config.responseType == 'blob')) {
          data = res.data;
        } else {
          data = thisJS.rwDecode(res.data);
        }

        //设置sessionid
        if (data.rwCookieID) {
          thisJS.setLocalSave('rwCookieID', data.rwCookieID);
        }

        if (data.wwwURL) {
          wwwURL = data.wwwURL;
        }

        //登录状态失效，跳转到登录
        if (data.status == 99) {
          window.location.href = wwwURL + "/?p=login&fromUrl=" + escape(window.location.href);
          return;
        }
        //权限相关问题
        if (data.status == 98) {
          //vueObj.$router.push({path:'/'+RootDirName,query:{p:'rwTip',a:'index',status:data.status,errorMsg:data.errorMsg}});
          vueObj.$bus.$emit('openTip', { status: data.status, errorMsg: data.errorMsg, url: obj.url });
          return;
        }
        if (obj.debug) {
          console.log(data);
        }
        resolve(data);
      }, res => {
        // if(thisJS.isMobile()){
        //   Notify({ 
        //     type: 'danger', 
        //     message: '网络异常，访问出错',
        //     duration:3000,
        //   });
        // }else{
        Message.error('网络异常，访问出错');
        // }
      })
    });
  }

  //设置客户端语言
  setClientLang(langName, callback) {
    this.setLocalSave('rwClientLang', langName, callback);
  }
  //获取客户端语言
  getClientLang() {
    var thisJS = this;
    var langName = this.getLocalSave('rwClientLang');
    if (!langName) {
      thisJS.setClientLang(ClientDefaultLang, function () {
        langName = ClientDefaultLang;
      });
    }
    return langName;
  }
  //获取本地储存值,暂时支持cookie存储
  getLocalSave(key) {
    var thisJS = this;
    var arr, reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
    arr = document.cookie.match(reg);
    if (arr) {
      return arr[2];
    }
    return '';
  }
  //设置本地储存值，暂时只支持cookie存储
  setLocalSave(key, val, callback) {
    document.cookie = key + '=' + val + ';domain=.' + DoMain;
    typeof (callback) == 'function' && callback();
  }
  removeLocalSave(key) {
    document.cookie = key + "=;domain=." + DoMain + ";expires=-1";
  }
  //判断当前环境是否为手机
  isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (flag) {
      return true;
    } else {
      return false;
    }
  }
  //隐藏手机号码中间三位
  hideMobileNumber(tel) {
    tel = tel.toString();
    return tel.substr(0, 3) + '****' + tel.substr(7);
  }
  //语言包字符替换
  replaceLang(text, data) {
    var langText = text.replace(/{{(.*?)}}/g, function () {
      return data[arguments[1]];
    });
    return langText;
  }
}





// WEBPACK FOOTER //
// ./src/assets/js/rwJS.js